export const phoneRegex = /((09|03|07|08|05)+([0-9]{8})\b)/g;

export const GET_ALL_MOVIE = "GET_ALL_MOVIE"
export const GET_DETAIL_MOVIE = "GET_DETAIL_MOVIE"
export const GET_ALL_MOVIE_PAGE = "GET_ALL_MOVIE_PAGE"

export const GET_ALL_USER_PAGE = "GET_ALL_USER_PAGE"
export const GET_ALL_USER= "GET_ALL_USER"
export const USER_LOGIN = 'USER_LOGIN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const USER_INFORMATION = 'USER_INFORMATION';


export const GET_ALL_CINEMA_BRAND = 'GET_ALL_CINEMA_BRAND';
export const GET_ALL_CINEMA = 'GET_ALL_CINEMA';
export const GET_ALL_CINEMA_SCHEDULE = 'GET_ALL_CINEMA_SCHEDULE';

export const TICKET_INFORMATION = 'TICKET_INFORMATION';
export const DAT_GHE = 'DAT_GHE';
export const XOA_GHE_DANG_CHON = 'XOA_GHE_DANG_CHON';




export const ACCESS_TOKEN = 'ACCESS_TOKEN';
